module.exports = __webpack_public_path__ + "media/images/hakone/hankyu_hakone_zh02-baf63100e61718bfdac77eacacdc58ad.jpg";